/**
 * Define the map from http routes to vue components
 */
export default [
  {
    path: '/login',
    meta: {
      public: true
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Login.vue`
    )
  },
  {
    path: '/register',
    meta: {
      public: true
    },
    name: 'Register',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Register.vue`
    )
  },
  {
    path: '/changePassword',
    meta: {
      public: true
    },
    name: 'ChangePassword',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Change.vue`
    )
  },
  {
    path: '/',
    meta: {
      frame: true,
      footer: true
    },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/chat',
    meta: {
      // frame: true
    },
    name: 'Chat',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/chat/ChatLayout.vue`
    ),
    redirect: {
      path: '/chat/messaging'
    },
    children: [
      {
        path: '/chat/messaging/:uuid?',
        meta: {
          frame: true
        },
        name: 'ChatMessaging',
        props: true,
        components: {
          default: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/components/chat/ChatMessaging.vue`
          )
        }
      }
    ]
  },
  {
    path: '/users/manageUsers',
    name: 'ManageUsers',
    component: () => import(
      `@/components/ManageUsers.vue`
    ),
    children: [
      {
        path: '/users/manageUsers/:email?/:change?',
        meta: {
          frame: true
        },
        name: 'User',
        props: true,
        components: {
          default: () => import(
            `@/components/ManageUsers.vue`
          )
        }
      }
    ]
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import(
      `@/components/Statistics.vue`
    )
  },
  {
    path: '/logs',
    name: 'Logs',
    component: () => import(
      `@/components/Logs.vue`
    )
  },
  {
    path: '/feedbacks',
    name: 'Feeedbacks',
    component: () => import(
      `@/components/Feedbacks.vue`
    )
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(
      `@/components/Settings.vue`
    )
  },
  {
    path: '/msgk/manageMsgks',
    name: 'ManageMsgks',
    component: () => import(
      `@/components/msgk/ManageMsgks.vue`
    ),
    children: [
      {
        path: '/msgk/manageMsgks/:materialGrp?',
        meta: {
          frame: true
        },
        name: 'Msgk',
        props: true,
        components: {
          default: () => import(
            `@/components/msgk/ManageMsgks.vue`
          )
        }
      }
    ]
  },
  {
    path: '/supplier/manageSuppliers',
    name: 'ManageSuppliers',
    component: () => import(
      `@/components/supplier/ManageSuppliers.vue`
    ),
    children: [
      {
        path: '/supplier/manageSuppliers/:supplierID?',
        meta: {
          frame: true
        },
        name: 'Supplier',
        props: true,
        components: {
          default: () => import(
            `@/components/supplier/ManageSuppliers.vue`
          )
        }
      }
    ]
  }
]
